module.exports = __webpack_public_path__ + "img/symbol_12.8dbe4221.png";